import {createStyles, makeStyles} from "@mui/styles";

export const CardActionsStyles = makeStyles(() =>
    createStyles({
        cardTableContent: {
            paddingLeft: '0rem !important',
            paddingRight: '0rem !important',
        },
    }),
);
